import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/close.svg'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-9 col-xl-8 col-lg-8 pe-xxl-6 mb-md-25" }
const _hoisted_3 = { class: "card border-0 shadow-sm rounded-3 mb-4" }
const _hoisted_4 = { class: "card-header bg-transparent border-bottom-0 pt-4 pb-0" }
const _hoisted_5 = { class: "fw-semibold mb-0" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-12" }
const _hoisted_9 = { class: "form-group mb-25" }
const _hoisted_10 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 0,
  class: "text-red fs-12 d-block mt-1"
}
const _hoisted_13 = { class: "col-lg-6" }
const _hoisted_14 = { class: "form-group mb-25" }
const _hoisted_15 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_16 = { value: undefined }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "col-lg-6" }
const _hoisted_19 = { class: "form-group mb-25" }
const _hoisted_20 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_21 = { value: undefined }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "col-lg-6" }
const _hoisted_24 = { class: "form-group mb-25" }
const _hoisted_25 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_26 = { value: undefined }
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "col-lg-6" }
const _hoisted_29 = { class: "form-group mb-25" }
const _hoisted_30 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_31 = {
  class: "emenu-control",
  for: "showOnEmenu"
}
const _hoisted_32 = { class: "emenu-control__content" }
const _hoisted_33 = { class: "emenu-control__title" }
const _hoisted_34 = { class: "fs-12 text-muted mb-0 mt-2" }
const _hoisted_35 = { class: "visually-hidden" }
const _hoisted_36 = { class: "card border-0 shadow-sm rounded-3 mb-4" }
const _hoisted_37 = { class: "card-header bg-transparent border-bottom-0 pt-4 pb-0" }
const _hoisted_38 = { class: "fw-semibold mb-0" }
const _hoisted_39 = { class: "card-body" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-lg-12" }
const _hoisted_42 = { class: "form-group mb-25" }
const _hoisted_43 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_44 = { value: 1 }
const _hoisted_45 = { value: 2 }
const _hoisted_46 = {
  key: 0,
  class: "col-lg-6"
}
const _hoisted_47 = { class: "form-group mb-25" }
const _hoisted_48 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_49 = ["required"]
const _hoisted_50 = { class: "col-lg-6" }
const _hoisted_51 = { class: "form-group mb-25" }
const _hoisted_52 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_53 = {
  key: 1,
  class: "col-lg-6"
}
const _hoisted_54 = { class: "form-group mb-25" }
const _hoisted_55 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_56 = {
  key: 2,
  class: "col-lg-6"
}
const _hoisted_57 = { class: "form-group mb-25" }
const _hoisted_58 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_59 = { class: "col-lg-6" }
const _hoisted_60 = { class: "form-group mb-25 position-relative" }
const _hoisted_61 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_62 = { class: "col-lg-6" }
const _hoisted_63 = { class: "form-group mb-25" }
const _hoisted_64 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_65 = { class: "w-100 bg_ash border-0 rounded-1 fs-14 text-optional p-2" }
const _hoisted_66 = { value: "1" }
const _hoisted_67 = { value: "2" }
const _hoisted_68 = { class: "card border-0 shadow-sm rounded-3 mb-4" }
const _hoisted_69 = { class: "card-header bg-transparent border-bottom-0 pt-4 pb-0" }
const _hoisted_70 = { class: "fw-semibold mb-0" }
const _hoisted_71 = { class: "card-body" }
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "col-lg-6" }
const _hoisted_74 = { class: "form-group mb-25" }
const _hoisted_75 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_76 = { class: "d-flex align-items-center gap-4 p-2 bg_ash rounded-1" }
const _hoisted_77 = { class: "form-check checkbox style-two m-0 d-flex align-items-center gap-2" }
const _hoisted_78 = {
  class: "form-check-label fs-14 mb-0",
  for: "typeBarcode"
}
const _hoisted_79 = { class: "form-check checkbox style-two m-0 d-flex align-items-center gap-2" }
const _hoisted_80 = {
  class: "form-check-label fs-14 mb-0",
  for: "typeQRcode"
}
const _hoisted_81 = {
  key: 0,
  class: "col-lg-6"
}
const _hoisted_82 = { class: "form-group mb-25" }
const _hoisted_83 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_84 = { class: "col-lg-6" }
const _hoisted_85 = { class: "form-group mb-25" }
const _hoisted_86 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_87 = ["placeholder"]
const _hoisted_88 = { class: "text-muted d-block w-100 fs-12 mt-1" }
const _hoisted_89 = { class: "col-lg-6" }
const _hoisted_90 = { class: "form-group mb-25" }
const _hoisted_91 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_92 = { class: "barcode-preview-container p-3 bg_ash rounded-1 d-flex flex-column align-items-center" }
const _hoisted_93 = {
  class: "bg-white p-2 rounded-1 w-100 d-flex justify-content-center mb-2",
  style: {"min-height":"80px"}
}
const _hoisted_94 = {
  key: 2,
  class: "text-muted fs-12 mt-4"
}
const _hoisted_95 = { class: "card border-0 shadow-sm rounded-3 mb-4" }
const _hoisted_96 = { class: "card-header bg-transparent border-bottom-0 pt-4 pb-0" }
const _hoisted_97 = { class: "fw-semibold mb-0" }
const _hoisted_98 = { class: "card-body" }
const _hoisted_99 = { class: "row" }
const _hoisted_100 = { class: "col-lg-12" }
const _hoisted_101 = { class: "form-group mb-25" }
const _hoisted_102 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_103 = { class: "d-flex gap-2 mb-3" }
const _hoisted_104 = { value: undefined }
const _hoisted_105 = ["value"]
const _hoisted_106 = ["placeholder"]
const _hoisted_107 = { key: 0 }
const _hoisted_108 = { class: "list-group border-0 gap-2" }
const _hoisted_109 = { class: "fw-semibold me-2" }
const _hoisted_110 = { class: "text-success fw-bold" }
const _hoisted_111 = ["onClick"]
const _hoisted_112 = ["alt"]
const _hoisted_113 = { class: "card border-0 shadow-sm rounded-3 mb-4" }
const _hoisted_114 = { class: "card-body" }
const _hoisted_115 = { class: "form-group mb-0" }
const _hoisted_116 = { class: "d-block fs-14 fw-semibold text-black mb-2" }
const _hoisted_117 = ["placeholder"]
const _hoisted_118 = { class: "d-flex gap-2 mb-4 mb-lg-0" }
const _hoisted_119 = {
  class: "btn style-one product-submit-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 px-5 py-2",
  type: "submit"
}
const _hoisted_120 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_121 = { class: "col-xxl-3 col-xl-4 col-lg-4 mt-4 mt-lg-0" }
const _hoisted_122 = {
  class: "card border-0 shadow-sm rounded-3 position-sticky",
  style: {"top":"20px"}
}
const _hoisted_123 = { class: "card-header bg-transparent border-bottom-0 pt-4 pb-0" }
const _hoisted_124 = { class: "fw-semibold mb-0" }
const _hoisted_125 = { class: "card-body" }
const _hoisted_126 = { class: "fs-12 text-muted mt-3 mb-0 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarcodeGenerator = _resolveComponent("BarcodeGenerator")!
  const _component_QRCodeGenerator = _resolveComponent("QRCodeGenerator")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AddImages = _resolveComponent("AddImages")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[23] || (_cache[23] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
    class: "product-form pb-60"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.$t("product_page.general_information")), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, [
                    _createTextVNode(_toDisplayString(_ctx.$t("product_page.product_name")) + " ", 1),
                    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "w-100 d-block shadow-none fs-14 bg_ash rounded-1 text-title border-0 p-2",
                    placeholder: _ctx.$t('product_page.enter_product_name'),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                    required: ""
                  }, null, 8, _hoisted_11), [
                    [_vModelText, _ctx.form.name]
                  ]),
                  (_ctx.duplicateName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t("product_page.duplicate_name_detected")), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("product_page.category")), 1),
                  _withDirectives(_createElementVNode("select", {
                    class: "w-100 bg_ash border-0 rounded-1 fs-14 text-optional p-2",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.category_id) = $event))
                  }, [
                    _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.$t("product_page.choose_category")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: cat.id,
                        value: cat.id
                      }, _toDisplayString(cat.name), 9, _hoisted_17))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.form.category_id]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("product_page.brand")), 1),
                  _withDirectives(_createElementVNode("select", {
                    class: "w-100 bg_ash border-0 rounded-1 fs-14 text-optional p-2",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.brand_id) = $event))
                  }, [
                    _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.$t("product_page.choose_brand")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brands, (b) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: b.id,
                        value: b.id
                      }, _toDisplayString(b.name), 9, _hoisted_22))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.form.brand_id]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("product_page.product_unit")), 1),
                  _withDirectives(_createElementVNode("select", {
                    class: "w-100 bg_ash border-0 rounded-1 fs-14 text-optional p-2",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.unit_id) = $event))
                  }, [
                    _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.$t("product_page.choose_product_unit")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.units, (u) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: u.id,
                        value: u.id
                      }, _toDisplayString(u.name), 9, _hoisted_27))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.form.unit_id]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("product_page.public_emenu")), 1),
                  _createElementVNode("label", _hoisted_31, [
                    _withDirectives(_createElementVNode("input", {
                      class: "emenu-control__input",
                      type: "checkbox",
                      id: "showOnEmenu",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.show_on_emenu) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.show_on_emenu]
                    ]),
                    _cache[25] || (_cache[25] = _createElementVNode("span", {
                      class: "emenu-control__switch",
                      "aria-hidden": "true"
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_32, [
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("product_page.show_on_public_emenu")), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["emenu-control__status", { 'is-enabled': _ctx.form.show_on_emenu }])
                      }, _toDisplayString(_ctx.form.show_on_emenu ? _ctx.$t("product_page.enabled") : _ctx.$t("product_page.disabled")), 3)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t("product_page.public_emenu_help")), 1),
                  _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.form.show_on_emenu ? _ctx.$t("product_page.enabled") : _ctx.$t("product_page.disabled")), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("h6", _hoisted_38, _toDisplayString(_ctx.$t("product_page.pricing_inventory")), 1)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t("product_page.product_type")), 1),
                  _withDirectives(_createElementVNode("select", {
                    class: "w-100 bg_ash border-0 rounded-1 fs-14 text-optional p-2",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.type) = $event))
                  }, [
                    _createElementVNode("option", _hoisted_44, _toDisplayString(_ctx.$t("product_page.standard_stockable")), 1),
                    _createElementVNode("option", _hoisted_45, _toDisplayString(_ctx.$t("product_page.service_non_stockable")), 1)
                  ], 512), [
                    [_vModelSelect, _ctx.form.type]
                  ])
                ])
              ]),
              (_ctx.form.type === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("label", _hoisted_48, [
                        _createTextVNode(_toDisplayString(_ctx.$t("product_page.product_cost")) + " ", 1),
                        _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        inputmode: "decimal",
                        class: "w-100 d-block shadow-none fs-14 bg_ash rounded-1 text-title border-0 p-2",
                        placeholder: "0.00",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.cost) = $event)),
                        required: _ctx.form.type === 1,
                        onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleDecimalFieldInput('cost'))),
                        onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.formatDecimalField('cost')))
                      }, null, 40, _hoisted_49), [
                        [_vModelText, _ctx.form.cost]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("label", _hoisted_52, [
                    _createTextVNode(_toDisplayString(_ctx.$t("product_page.product_price")) + " ", 1),
                    _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    inputmode: "decimal",
                    class: "w-100 d-block shadow-none fs-14 bg_ash rounded-1 text-title border-0 p-2",
                    placeholder: "0.00",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.price) = $event)),
                    required: "",
                    onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleDecimalFieldInput('price'))),
                    onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.formatDecimalField('price')))
                  }, null, 544), [
                    [_vModelText, _ctx.form.price]
                  ])
                ])
              ]),
              (_ctx.form.type === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("label", _hoisted_55, [
                        _createTextVNode(_toDisplayString(_ctx.$t("product_page.product_quantity")) + " ", 1),
                        _cache[28] || (_cache[28] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "w-100 d-block shadow-none fs-14 bg_ash rounded-1 text-title border-0 p-2",
                        placeholder: "0",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.qty) = $event)),
                        required: ""
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.form.qty,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.form.type === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t("product_page.stock_alert")), 1),
                      _cache[29] || (_cache[29] = _createElementVNode("input", {
                        type: "number",
                        class: "w-100 d-block shadow-none fs-14 bg_ash rounded-1 text-title border-0 p-2",
                        placeholder: "0"
                      }, null, -1))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("label", _hoisted_61, [
                    _createTextVNode(_toDisplayString(_ctx.$t("product_page.order_tax")) + " ", 1),
                    _cache[30] || (_cache[30] = _createElementVNode("span", { class: "text-muted fs-12" }, "(%)", -1))
                  ]),
                  _cache[31] || (_cache[31] = _createElementVNode("input", {
                    type: "number",
                    class: "w-100 d-block shadow-none fs-14 bg_ash rounded-1 text-title border-0 p-2 pe-4",
                    placeholder: "0"
                  }, null, -1)),
                  _cache[32] || (_cache[32] = _createElementVNode("span", {
                    class: "position-absolute end-0 top-50 translate-middle-y mt-2 pe-3 text-muted",
                    style: {"margin-top":"5px"}
                  }, "%", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t("product_page.tax_type")), 1),
                  _createElementVNode("select", _hoisted_65, [
                    _createElementVNode("option", _hoisted_66, _toDisplayString(_ctx.$t("product_page.inclusive")), 1),
                    _createElementVNode("option", _hoisted_67, _toDisplayString(_ctx.$t("product_page.exclusive")), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("h6", _hoisted_70, _toDisplayString(_ctx.$t("product_page.barcode_identification")), 1)
          ]),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t("product_page.code_type")), 1),
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input m-0 flex-shrink-0",
                        style: {"width":"1rem","height":"1rem"},
                        type: "radio",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.codeType) = $event)),
                        value: "barcode",
                        id: "typeBarcode"
                      }, null, 512), [
                        [_vModelRadio, _ctx.codeType]
                      ]),
                      _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.$t("product_page.barcode")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input m-0 flex-shrink-0",
                        style: {"width":"1rem","height":"1rem"},
                        type: "radio",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.codeType) = $event)),
                        value: "qrcode",
                        id: "typeQRcode"
                      }, null, 512), [
                        [_vModelRadio, _ctx.codeType]
                      ]),
                      _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t("product_page.qr_code")), 1)
                    ])
                  ])
                ])
              ]),
              (_ctx.codeType === 'barcode')
                ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.$t("product_page.symbology")), 1),
                      _withDirectives(_createElementVNode("select", {
                        class: "w-100 bg_ash border-0 rounded-1 fs-14 text-optional p-2",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.barcodeFormat) = $event))
                      }, [...(_cache[33] || (_cache[33] = [
                        _createStaticVNode("<option value=\"CODE128\" data-v-fa090350>CODE128</option><option value=\"CODE39\" data-v-fa090350>CODE39</option><option value=\"EAN13\" data-v-fa090350>EAN13</option><option value=\"EAN8\" data-v-fa090350>EAN8</option><option value=\"UPC\" data-v-fa090350>UPC</option><option value=\"ITF14\" data-v-fa090350>ITF14</option>", 6)
                      ]))], 512), [
                        [_vModelSelect, _ctx.barcodeFormat]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("label", _hoisted_86, [
                    _createTextVNode(_toDisplayString(_ctx.$t("product_page.product_code")) + " ", 1),
                    _cache[34] || (_cache[34] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "w-100 d-block shadow-none fs-14 bg_ash rounded-1 text-title border-0 p-2",
                    placeholder: _ctx.$t('product_page.scan_or_enter_code'),
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.code) = $event)),
                    required: ""
                  }, null, 8, _hoisted_87), [
                    [_vModelText, _ctx.form.code]
                  ]),
                  _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.$t("product_page.scan_barcode_helper")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.$t("product_page.preview")), 1),
                  _createElementVNode("div", _hoisted_92, [
                    _createElementVNode("div", _hoisted_93, [
                      (_ctx.codeType === 'barcode' && _ctx.form.code)
                        ? (_openBlock(), _createBlock(_component_BarcodeGenerator, {
                            key: 0,
                            value: _ctx.form.code,
                            format: _ctx.barcodeFormat,
                            height: 40,
                            width: 1.5
                          }, null, 8, ["value", "format"]))
                        : _createCommentVNode("", true),
                      (_ctx.codeType === 'qrcode' && _ctx.form.code)
                        ? (_openBlock(), _createBlock(_component_QRCodeGenerator, {
                            key: 1,
                            value: _ctx.form.code,
                            size: 60
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true),
                      (!_ctx.form.code)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_94, _toDisplayString(_ctx.$t("product_page.code_preview")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-primary btn-sm w-100 border-1",
                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.generateBarcode && _ctx.generateBarcode(...args)))
                    }, _toDisplayString(_ctx.$t("product_page.generate_random_code")), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("h6", _hoisted_97, _toDisplayString(_ctx.$t("product_page.variants_sizes")), 1)
          ]),
          _createElementVNode("div", _hoisted_98, [
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("label", _hoisted_102, _toDisplayString(_ctx.$t("product_page.add_product_size_variants")), 1),
                  _createElementVNode("div", _hoisted_103, [
                    _withDirectives(_createElementVNode("select", {
                      class: "bg_ash border-0 rounded-1 fs-14 text-optional p-2 flex-grow-1",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.selectedSizeId) = $event))
                    }, [
                      _createElementVNode("option", _hoisted_104, _toDisplayString(_ctx.$t("product_page.choose_size")), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizes, (s) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: s.id,
                          value: s.id
                        }, _toDisplayString(s.name) + " (" + _toDisplayString(s.code) + ")", 9, _hoisted_105))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.selectedSizeId]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      inputmode: "decimal",
                      class: "bg_ash border-0 rounded-1 fs-14 text-title p-2 w-25",
                      placeholder: _ctx.$t('product_page.variant_price'),
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.selectedSizePrice) = $event)),
                      onInput: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.handleSelectedSizePriceInput && _ctx.handleSelectedSizePriceInput(...args))),
                      onBlur: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.formatSelectedSizePrice && _ctx.formatSelectedSizePrice(...args)))
                    }, null, 40, _hoisted_106), [
                      [_vModelText, _ctx.selectedSizePrice]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary px-4",
                      onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.addSizePrice && _ctx.addSizePrice(...args)))
                    }, _toDisplayString(_ctx.$t("product_page.add")), 1)
                  ]),
                  (_ctx.form.product_sizes && _ctx.form.product_sizes.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                        _createElementVNode("ul", _hoisted_108, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.product_sizes, (ps, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: index,
                              class: "list-group-item d-flex justify-content-between align-items-center bg_ash border-0 rounded-1 px-3 py-2 fs-14 text-title"
                            }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_109, _toDisplayString(_ctx.getSizeName(ps.size_id)), 1),
                                _createElementVNode("span", _hoisted_110, "$" + _toDisplayString(ps.price), 1)
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-light text-danger bg-white border-0 py-1",
                                onClick: ($event: any) => (_ctx.removeSizePrice(index))
                              }, [
                                _createElementVNode("img", {
                                  src: _imports_0,
                                  alt: _ctx.$t('product_page.remove'),
                                  style: {"width":"12px","opacity":"0.6"}
                                }, null, 8, _hoisted_112)
                              ], 8, _hoisted_111)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_113, [
          _createElementVNode("div", _hoisted_114, [
            _createElementVNode("div", _hoisted_115, [
              _createElementVNode("label", _hoisted_116, _toDisplayString(_ctx.$t("product_page.internal_notes")), 1),
              _createElementVNode("textarea", {
                cols: "30",
                rows: "4",
                placeholder: _ctx.$t('product_page.add_note_about_product'),
                class: "d-block w-100 bg_ash border-0 rounded-1 resize-none fs-14 text-title p-3"
              }, null, 8, _hoisted_117)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_118, [
          _createElementVNode("button", _hoisted_119, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_120))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.isEdit ? _ctx.$t("product_page.update_product") : _ctx.$t("product_page.submit_product")), 1)
          ]),
          _createVNode(_component_router_link, {
            to: "/product-list",
            class: "btn btn-light rounded-1 px-4 py-2 text-dark"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("common.cancel")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_121, [
        _createElementVNode("div", _hoisted_122, [
          _createElementVNode("div", _hoisted_123, [
            _createElementVNode("h6", _hoisted_124, _toDisplayString(_ctx.$t("product_page.product_images")), 1)
          ]),
          _createElementVNode("div", _hoisted_125, [
            (_openBlock(), _createBlock(_component_AddImages, {
              key: _ctx.addImagesKey,
              existingImages: _ctx.existingAttachments.map(a => a.url),
              "onUpdate:files": _ctx.handleFilesUpdate,
              "onRemove:existing": _ctx.handleRemoveExisting
            }, null, 8, ["existingImages", "onUpdate:files", "onRemove:existing"])),
            _createElementVNode("p", _hoisted_126, [
              _createTextVNode(_toDisplayString(_ctx.$t("product_page.recommended_image_size")) + " ", 1),
              _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("product_page.max_file_size")), 1)
            ])
          ])
        ])
      ])
    ])
  ], 32))
}